import { Fragment } from 'react';
import { SearchBar, Tooltip, IconButton, DropdownSelect } from '@shared/components';
import { X } from "lucide-react";
import styles from './DataTableToolbar.module.css';

function DataTableToolbar({
  columns = [],
  filterableFields = [],
  filterOptions = {},
  filters = {},
  setFilters,
  search,
  setSearch,
}) {

  return (
    <div className={styles.toolbar}>
      {/* Search Field */}
      <SearchBar
        label="Search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        showSearchIcon
      />

      {/* Dropdown filters */}
      {filterableFields.map((field, index) => {
        const options = filterOptions[field] || [];
        const col = columns.find((c) => c.key === field);
        const label = col?.label ?? field;
        return (
          <Fragment key={index}>
            <DropdownSelect
              label={label}
              value={filters[field] ?? ""}
              options={options}
              onChange={(e) => setFilters((prev) => ({ ...prev, [field]: e.target.value }))}
            />
          </Fragment>
        );
      })}

      <Tooltip title="Clear filters" placement="top">
        <IconButton
        size="2.4rem"
        color="var(--color-dark-grey)"
          onClick={() => {
            setFilters({});
            setSearch("");
          }}
        >
          <X />
        </IconButton>
      </Tooltip>
    </div>
  );
}

export default DataTableToolbar;